import React, { useEffect } from "react"
import { Navigate, Route, Routes } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth0 } from "@auth0/auth0-react"

import PortalRouter from "Pages/Main/PortalRouter"
import AdminConsoleRouter from "Pages/Main/AdminConsoleRouter"

import { webUrl } from "Shared/utils"

function App() {
  const { user, error, isAuthenticated, isLoading, loginWithRedirect, logout } = useAuth0()
  const { t } = useTranslation()

  useEffect(() => {
    const init = async () => {
      if (!isLoading) {
        if (!error) {
          if (!isAuthenticated) {
            loginWithRedirect({ appState: { returnTo: window.location.pathname } })
          }
        }
        else {
          const errorMsg = new String(error).toString()
  
          switch (errorMsg) {
            case "Error: Please verify your email before logging in.":
              alert(t("loginError_unverified"))
              break
            case "Error: client requires organization membership, but user does not belong to any organization":
              alert(t("loginError_noOrg"))
              break
            default:
              alert(errorMsg)
              break
          }
  
          logout({ logoutParams: { returnTo: webUrl } })
        }
      }
    }

    init()
  }, [isLoading, isAuthenticated])

  if (!user) {
    return(<div></div>)
  }

  return (<>
    <Routes>
      <Route path='/portal/:organization?/:project?/*' element={<PortalRouter/>} />
      <Route path='/admin_console/:organization?/*' element={<AdminConsoleRouter />} />

      <Route index element={<Navigate to="./portal" replace />} />
    </Routes>
  </>)
}

export default App
